import dotsImg from "@/assets/dots-img.png";
import satelliteMap from "@/assets/rioplex-satellite-map.webp";
import { useScrollReveal } from "@/hooks/useScrollReveal";
const AboutSection = () => {
  const image = useScrollReveal();
  const content = useScrollReveal();
  const dots = useScrollReveal({ threshold: 0.05 });
  return (
    <section className="bg-white pt-16 pb-48 px-4 relative">
      {/* Wrapper for content with overflow hidden to clip dots */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Dots decoration - top right */}
        <img
          ref={dots.ref as React.Ref<HTMLImageElement>}
          src={dotsImg}
          alt=""
          className={`absolute -top-[180px] -right-[60px] w-[30rem] h-[30rem] transition-all duration-1000 ease-out ${
            dots.isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"
          }`}
        />
      </div>
      
      {/* Decorative circle at the bottom edge - outside overflow wrapper so it shows on both sections */}
      <div 
        className="absolute bottom-0 left-0 -translate-x-1/2 translate-y-1/2 w-[27rem] h-[27rem] md:w-[36rem] md:h-[36rem] rounded-full z-20 blur-2xl pointer-events-none"
        style={{
          background: "radial-gradient(circle, hsl(153 92% 59% / 0.4) 0%, hsl(153 92% 59% / 0) 70%)"
        }}
      />

      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col lg:flex-row gap-12 items-stretch">
          {/* Image on the left */}
          <div
            ref={image.ref}
            className={`w-full lg:w-[40%] flex justify-center transition-all duration-700 ease-out ${
              image.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="relative p-4">
              {/* Gradient border overlay */}
              <div
                className="absolute inset-0 rounded-[180px] pointer-events-none"
                style={{
                  border: "0.75px solid transparent",
                  background:
                    "linear-gradient(to bottom, hsla(153, 92%, 25%, 0.1) 0%, hsla(153, 92%, 25%, 1) 30%, hsla(153, 92%, 25%, 1) 70%, hsla(153, 92%, 25%, 0.1) 100%)",
                  WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                  WebkitMaskComposite: "xor",
                  maskComposite: "exclude",
                }}
              />
              <img
                src={satelliteMap}
                alt="RioPlex satellite map showing Texas and Mexico border region"
                loading="lazy"
                className="w-full max-w-[280px] lg:max-w-none h-auto rounded-[180px] object-cover aspect-[3/4]"
              />
            </div>
          </div>

          {/* Vertical divider */}
          <div className="hidden lg:block w-[1px] self-stretch bg-black/25" />

          {/* Content on the right */}
          <div
            ref={content.ref}
            className={`w-full lg:w-[60%] space-y-6 transition-all duration-700 ease-out delay-200 ${
              content.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <h2 className="text-4xl md:text-5xl">
              <span className="font-gotham-xlight text-black text-7xl">What is</span>
              <br className="md:hidden lg:block" />
              <span className="font-gotham-bold text-primary text-7xl"> RioPlex</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-600 font-gotham">
              <p>
                RioPlex is a strategic organization uniting the Rio Grande Valley in{" "}
                <span className="font-gotham-bold">South Texas</span> and{" "}
                <span className="font-gotham-bold">northern Tamaulipas</span> to attract Foreign Direct Investment
                (FDI).
              </p>
              <p>
                By fostering collaboration between the private sector, government, and nonprofits, it drives industrial
                growth, boosts cross-border trade, and accelerates investment.
              </p>
              <p>
                As a key hub for North American competitiveness, it strengthens U.S.-Mexico economic ties, fostering
                business expansion and long-term prosperity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutSection;
